import React from 'react';
import { Button, } from 'reactstrap';
import { mapValues, pick, last, sortBy, omit } from 'lodash';
import { toast } from 'react-toastify';
import { useToggle } from 'react-use';
import { format as formatDate } from 'date-fns';
import classnames from 'classnames';
import retry from 'async-retry';

import firebase, { functions } from '../../firebase';
import { fieldDisplayValue } from '../../shared/util';
import { generalSettingsFields } from '../../shared/models/company';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import HelpLink from '../HelpLink';
import CompanyPage from '../hocs/CompanyPage';
import ModelFormModal from '../modals/ModelFormModal';
import PeriodSettingFormModal from '../modals/PeriodSettingFormModal';
import EditButton from '../EditButton';
import ModalButton from '../ModalButton';

const { entries, keys } = Object;
const db = firebase.firestore();
const companiesRef = db.collection('companies');
const updateGeneralSettings = functions.httpsCallable('updateGeneralSettings');

export default CompanyPage(CompanyGeneralSettings);

function CompanyGeneralSettings(props) {
  const { user, company, accountItems, } = props;
  const onSubmitGeneralSettings = async (values, { onClickClose }) => {
    await updateGeneralSettings({ companyId: company.id, values });
    toast.success('保存しました');
    onClickClose();
  };

  return (
    <div className="company-custom-sections">
      <div className="container py-5">
        <div className="d-flex justify-content-center mb-2">
          <h4>事業所設定</h4>
        </div>
        <div className="d-flex justify-content-end mb-3 gap-1">
          <EditButton label="会計期間編集" itemRef={company.ref} FormModal={PeriodSettingFormModal} formProps={{ company, }} />
          <ModalButton color="primary" Modal={ModelFormModal} modalProps={{ title: '事業所設定', fields: generalSettingsFields(company, accountItems), values: company, onSubmit: onSubmitGeneralSettings }}>
            <span className="fas fa-edit mr-1" />
            編集
          </ModalButton>
        </div>
        <div>
          <table className="table table-hover table-bordered">
            <tbody className="thead-light">
              {
                entries(generalSettingsFields(company, accountItems)).map(([fieldName, fieldSetting]) => {
                  const { label, hidden = _ => false, } = fieldSetting;
                  return !hidden(company) && (
                    <tr key={fieldName}>
                      <th style={{ width: 300 }}>{label}</th>
                      <td style={{ wordBreak: 'break-all', }}>{fieldDisplayValue(company[fieldName], fieldSetting)}</td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
